"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * Converts an array of property names with an array of corresponding values to an
 * object.
 * @param {Array<string>} propNames An array of property names. A dot in the property
 * name indicates nesting. For example, the property name `"foo.bar"` indicates that
 * the result should have an object `foo` with the property `bar`.
 * @param {Array} propValues An array of values that correspond to the property names
 * in the `propNames` array.
 * @returns {object} The result object
 */
var _default = function _default(propNames, propValues) {
  return propNames.reduce(function (result, propName, index) {
    var segments = propName.split('.');

    if (segments.length < 2) {
      result[propName] = propValues[index]; // eslint-disable-line no-param-reassign
    } else {
      var finalPropName = segments.pop();
      var target = result;
      segments.forEach(function (segment) {
        if (_typeof(target[segment]) !== 'object') {
          target[segment] = {};
        }

        target = target[segment];
      });
      target[finalPropName] = propValues[index];
    }

    return result;
  }, {});
};

exports.default = _default;